import { Injectable } from '@angular/core';

import { AzavistaApiService, ICreateEventActivityRequest, IEvent, IEventActivity, ISearchActivityConditionsRequest, ISearchActivityGroupsRequest, PageSubtype, PageType } from '@azavista/servicelib';
import { AzavistaInputFieldService } from '@azavista/components/input-field';
import { IAzavistaSideInfoData } from '@azavista/components/side-info';
import { IAzavistaGroupedFieldsComponentData, IGroupedFieldOptions, omit } from '@azavista/components/shared';
import { EventContentActivitiesService } from '../event-content-activities.service';
import { IconName, SharedService } from '../../../shared';

@Injectable({
    providedIn: 'root'
})
export class EventContentActivityService {

    constructor(
        private evtActivitiesSvc: EventContentActivitiesService, private inputFldSvc: AzavistaInputFieldService,
        private sharedSvc: SharedService, private apiSvc: AzavistaApiService
    ) { }

    getSideInfoData(event: IEvent, eventActivity: IEventActivity, eventTimeZone: string, dateTimeFormat: string): IAzavistaSideInfoData {
        const result: IAzavistaSideInfoData = {
            eventName: event?.name,
            name: eventActivity.name,
            values: [
                {
                    icon: IconName.date_range, text:
                        this.inputFldSvc.getDateWithTimezone(eventActivity.start, eventTimeZone, dateTimeFormat)
                },
                {
                    icon: IconName.date_range,
                    text: this.inputFldSvc.getDateWithTimezone(eventActivity.end, eventTimeZone, dateTimeFormat)
                },
            ]
        };
        return result;
    }

    async createActivityGroupedFields(eventId: string, activity: IEventActivity, eventTimeZone: string): Promise<IAzavistaGroupedFieldsComponentData> {
        const fieldsOptions: IGroupedFieldOptions[] = [];
        // TODO: Create API service functions for get all activity groups and conditions
        const activityGroupsReq: ISearchActivityGroupsRequest = {
            limit: 50, offset: 0
        };
        const activityGroupsRes = await this.apiSvc.searchActivityGroups(eventId, activityGroupsReq);
        const activityConditionsReq: ISearchActivityConditionsRequest = {
            limit: 50, offset: 0
        };
        const activityConditionsRes = await this.apiSvc.searchActivityConditions(eventId, activityConditionsReq);
        const allEventPages = await this.apiSvc.getAllPages(PageType.page, eventId);
        const eventAppPages = allEventPages.filter(x => x.page_subtype === PageSubtype.eventApp);
        const notFilteredColumns = this.evtActivitiesSvc.getEventActivitiesColumns(eventTimeZone);
        this.evtActivitiesSvc.addActivityGroupAndConditionFields(
            notFilteredColumns, activityGroupsRes.activity_groups, activityConditionsRes.activity_conditions, eventAppPages, fieldsOptions
        );

        const eventActivitiesColumns = this.evtActivitiesSvc.getColumnsWithFilteredSettingsFields(notFilteredColumns);
        // Add the status field
        // We need to clone original activity
        const clonedActivity = this.sharedSvc.clone(activity);

        // // Add activity group and condition fields
        // const activityGroupIdField = eventActivitiesColumns.find(x => x.name === 'activity_group_id');
        // const activityGroupsObjectEnumItems = this.sharedSvc.getObjectsIdWithLabel(activityGroupsRes.activity_groups);
        // const activityGroupIdFieldValue = this.sharedSvc.createDefaultObjectEnumInputFieldValueReportingId(
        //     activityGroupsObjectEnumItems, activity.activity_group_id
        // );
        // clonedActivity.activity_group_id = activityGroupIdFieldValue as any;


        return {
            disableAutoOrdering: true,
            expandPanels: true,
            editModeForAllFields: false,
            singleColumn: false,
            fieldsWithEntity: {
                entity: clonedActivity,
                fields: eventActivitiesColumns
            },
            fieldsOptions: fieldsOptions
        };
    }

    async duplicateActivity(activityId: string, eventId: string): Promise<void> {
        const activityToDuplicate = omit(await this.apiSvc.getEventActivity(activityId), ['id']);
        activityToDuplicate.name = activityToDuplicate.name + ' copy';
        if (activityToDuplicate.short_name) {
            activityToDuplicate.short_name += ' copy';
        }
        const req: ICreateEventActivityRequest = {
            eventId: eventId, eventActivity: activityToDuplicate
        };
        const createdActivity = await this.apiSvc.createEventActivity(req);
        if (createdActivity?.id) {
            const activitySettingsToDuplicate = omit(await this.apiSvc.getEventActivitySettings(activityId), ['event_settings']);
            await this.apiSvc.updateEventActivitySettings(createdActivity.id, activitySettingsToDuplicate);
        }
    }
}

